import type { CSSObject } from 'styled-components';

/**
 * Local stand-ins for the Frontend-Platform theme mixins, expressed against
 * Daffy's `--cl-*` CSS variables (defined by `@usealloy/component-library`'s
 * global stylesheet) since Daffy does not provide a styled-components theme.
 *
 * Defined as plain `CSSObject`s so they can be spread into object-notation
 * styled components, mirroring FE2.0's `...theme.mixins.truncateText()` usage.
 */

/**
 * Single-line text truncation (FE2.0 `theme.mixins.truncateText()`)
 */
export const truncateText: CSSObject = {
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

/**
 * Small body text (FE2.0 `theme.typography.mixins.body({ size: 'small' })`)
 */
export const bodySmallText: CSSObject = {
  fontFamily: 'var(--cl-font-family-default)',
  fontWeight: 'var(--cl-font-weight-regular)',
  fontSize: 'var(--cl-font-size-1)',
  lineHeight: 'var(--cl-line-height-1)',
};

/**
 * Focus ring for non-input interactive elements (FE2.0 `theme.mixins.nonInputFocus()`)
 *
 * Only applies on `:focus-visible` so mouse clicks don't show the ring.
 */
export const nonInputFocus: CSSObject = {
  outline: 'none',

  '&:focus-visible': {
    '--shadow-color': 'var(--cl-border-focus-ring)',
    boxShadow: [
      '0px 0px 0px 1px var(--shadow-color)',
      '0px 0px 0px 3px oklch(from var(--shadow-color) l c h / 0.2)',
    ].join(', '),
  },
};
